export default "__VITE_ASSET__RRlvhfDY__"